import { Link, styled } from '@mui/material';

import { Link as RouterLink } from 'react-router';

import { useI18n } from '@app-velocity/i18n';

import { Divider, Typography } from '@app-velocity/ui';

import { AuthRoutesPaths } from '@app-velocity/libs/auth';

import { StartPage } from '../../components/StartPage';

const DividerContainer = styled('div')({
  padding: '0px 45%',
  boxSizing: 'border-box',
  width: '100%',
});

const Links = styled('div')(({ theme }) => ({
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const Guest = () => {
  const { t } = useI18n();

  return (
    <StartPage
      mode="guest"
      bottom={
        <>
          <DividerContainer>
            <Divider text="" />
          </DividerContainer>
          <Links>
            <Typography>
              {t('users:auth.already_have_an_account')}{' '}
              <Link component={RouterLink} to={AuthRoutesPaths.Login}>
                {t('users:auth.sign_in')}
              </Link>
            </Typography>
            <Typography>
              {t('users:auth.new_here')}{' '}
              <Link component={RouterLink} to={AuthRoutesPaths.Registration}>
                {t('users:auth.sign_up')}
              </Link>
            </Typography>
          </Links>
        </>
      }
    />
  );
};
